import React from "react";
import { Helmet } from "react-helmet";
import { AppName } from "../../../../util/app";

const RiskDetail = ({ item }) => {
    return (
        <>
            <Helmet>
                <title> Patient Risk Matrix | {AppName}</title>
            </Helmet>

            <div className="row">
                <div className="col-4 bg-primary">
                    <h5>Risk Matrix</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "60%", backgroundColor: "aliceblue" }}>
                                <strong>Risk Area</strong>
                            </td>
                            <td style={{ width: "20%", backgroundColor: "aliceblue" }} className="text-center">
                                <strong>Current</strong>
                            </td>
                            <td style={{ width: "20%", backgroundColor: "aliceblue" }} className="text-center">
                                <strong>Historical</strong>
                            </td>
                        </tr>
                        {item.assessments.map((i, idx) => (
                            <tr>
                                <td style={{ width: "60%", backgroundColor: "aliceblue" }}>
                                    <strong>{i.key}</strong>
                                </td>
                                <td style={{ width: "20%" }} className="text-center">
                                    {i.value === "Yes" ? <span className="badge badge-danger">{i.value}</span> : <span className="badge badge-success">{i.value}</span>}
                                </td>
                                <td style={{ width: "20%" }} className="text-center">
                                    <strong className="text-primary">{i.historical}</strong>
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td style={{ width: "60%", backgroundColor: "aliceblue" }}>
                                <strong>Comments</strong>
                            </td>
                            <td colSpan="2" style={{ width: "20%" }}>
                                <p>{item.comment}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default RiskDetail;
